import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const ModalFooter = ({ children, className, ...props }) => (
  <div className={classnames(className, 'modal-footer')} data-testid="ModalFooter" {...props}>
    {children}
  </div>
);

ModalFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalFooter.defaultProps = {
  children: null,
  className: null,
};

export default ModalFooter;
